import React from 'react';
import { useParams } from 'react-router-dom';

import ToggleOption from '@/components/common/ToggleOption/ToggleOption';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import useToggleConsolidateBilling from './hooks/useToggleConsolidateBilling';
import { EDITABLE_STATUS_KEYS } from '@/config/statuses.config';

export default function ConsolidateBillingContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const { contract } = useGetContractDetails(contractId);
  const { toggleConsolidateBilling } = useToggleConsolidateBilling(contractId);

  const onChange = () => {
    toggleConsolidateBilling(!Boolean(contract?.consolidateBilling));
  };

  const isVisible = contract && EDITABLE_STATUS_KEYS.includes(contract?.status.status);

  if (!isVisible) {
    return null;
  }

  return (
    <ToggleOption
      title="Consolidate Billing"
      id="consolidated-billing"
      onChange={onChange}
      isEnable={Boolean(contract?.consolidateBilling)}
    />
  );
}
